import { render } from "./edit_complaint.vue?vue&type=template&id=e77dcc9e"
import script from "./edit_complaint.vue?vue&type=script&lang=js"
export * from "./edit_complaint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__